// auto-edit-diff.ts — the pure transform-chain runner for the auto-edit queue.
//
// Extracted so it can be unit-tested WITHOUT importing auto-edit-queue.ts (whose
// IIFE pulls in note-editor → window.CM6, unavailable under jsdom). No DOM, no
// editor, no window — just string math over the transform chain.

/** A registered transform: a named, pure `(text, ctx) -> text` rewrite. */
export interface Transform {
  name: string;
  fn: (text: string, ctx: any) => string;
}

/**
 * Run the transform chain over `before`, recording which transforms actually
 * changed the text (per-transform attribution — the plain reduce loses it). A
 * throwing transform is logged and skipped (its input carries forward), matching
 * the queue's existing catch behaviour.
 */
export function diffTransforms(
  before: string,
  transforms: Transform[],
  ctx: any
): { text: string; changedBy: string[] } {
  let text = before;
  const changedBy: string[] = [];
  for (const { name, fn } of transforms) {
    let out: string;
    try {
      out = fn(text, ctx);
    } catch (e) {
      console.error('[auto-edit-queue] transform failed:', e);
      continue;
    }
    if (out !== text) changedBy.push(name);
    text = out;
  }
  return { text, changedBy };
}
